<template>
    <EditModelLayout
        :indexRoute="$route('admin::vacation-message-defaults.index')"
        :updateRoute="$route('admin::vacation-message-defaults.update', { vacation_message_default: vacationMessageDefault.id })"
        :modelNameSingular="__('admin::vacation-message-defaults.vacation_message_default')"
        :modelNamePlural="__('admin::vacation-message-defaults.vacation_message_defaults')"
        :form="form"
        :name="form.name"
    >

        <FormGroup :label="__('admin::labels.name')" :error="errors.name">
            <Input name="name" type="text" :has-error="exists(errors.name)" v-model="form.name" :required="true" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.priority')" :error="errors.priority">
            <Input name="priority" type="number" step="1" :has-error="exists(errors.priority)" v-model="form.priority" :required="true" />
        </FormGroup>

        <FormGroup class="mb-4">
            <Toggle v-model:checked="form.is_active" :label="__('admin::labels.is_active')" />
        </FormGroup>

        <Heading type="h2" class="mt-4">{{ __('admin::labels.criteria') }}</Heading>

        <Criteria
            :criteriumOptions="criteriumOptions"
            v-model="form.criteria"
        />

        <Heading type="h2" class="mt-4">{{ __('admin::labels.texts') }}</Heading>

        <FormGroup :label="__('admin::labels.appendix_before_vacation_message')" :error="errors.appendix_before_vacation_message">
            <MarkdownEditor name="appendix_before_vacation_message" v-model="form.appendix_before_vacation_message" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.appendix_during_vacation_message')" :error="errors.appendix_during_vacation_message">
            <MarkdownEditor name="appendix_during_vacation_message" v-model="form.appendix_during_vacation_message" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.autoreply_subject')" :error="errors.autoreply_subject">
            <Input name="autoreply_subject" type="text" :has-error="exists(errors.autoreply_subject)" v-model="form.autoreply_subject" :required="false" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.autoreply_message')" :error="errors.autoreply_message">
            <MarkdownEditor name="autoreply_message" v-model="form.autoreply_message" :required="false" />
        </FormGroup>

    </EditModelLayout>
</template>

<script>
    export default {
        props: {
            errors: Object,
            vacationMessageDefault: Object,
            criteriumOptions: Object,
        },
        data() {
            return {
                form: this.$inertia.form({
                    name: this.vacationMessageDefault.name,
                    is_active: this.vacationMessageDefault.is_active,
                    priority: this.vacationMessageDefault.priority,
                    criteria: this.vacationMessageDefault.criteria || [],
                    appendix_before_vacation_message: this.vacationMessageDefault.appendix_before_vacation_message,
                    appendix_during_vacation_message: this.vacationMessageDefault.appendix_during_vacation_message,
                    autoreply_subject: this.vacationMessageDefault.autoreply_subject,
                    autoreply_message: this.vacationMessageDefault.autoreply_message,
                })
            }
        },
    }
</script>
